<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد مقاله
        </b-button>
      </b-col>
    </b-row>
    <div v-if="news">
      <div class="d-flex align-items-center mb-2 gap-1">
        <b-input-group size="sm" class="w-25 ml-1">
          <b-form-input
              v-model="searchId"
              placeholder="جستجو براساس ID"
              type="number"
              class="border-right-0"
          />
        </b-input-group>
        <b-input-group size="sm" class="w-25 ml-1">
          <b-form-input
              v-model="searchTitle"
              placeholder="جستجو براساس عنوان"
              class="border-right-0"
          />
        </b-input-group>

        <b-input-group size="sm" class="w-25 ml-1">
          <b-form-input
              v-model="searchSlug"
              placeholder="جستجو براساس Slug"
              class="border-right-0"
          />
        </b-input-group>



        <b-button size="sm" variant="primary" @click="getNews" class="px-2">
          <feather-icon icon="SearchIcon" size="16" />
        </b-button>
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>id</b-th>
            <b-th>تصویر</b-th>
            <b-th>عنوان</b-th>
            <b-th>دسته بندی</b-th>
            <b-th>نویسنده</b-th>
            <b-th>وضعیت مقاله</b-th>
            <b-th>تاریخ</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="article in news" :key="article.id">
            <b-td>{{ article.id }}</b-td>
            <b-th>
              <img
                  v-if="article.image"
                  style="border-radius: 15px; width: 35px"
                  :src="$http.defaults.fileUrl+'/' + article.image"
              /></b-th>
            <b-td>{{ article.title }}</b-td>
            <b-td>
              <!--              <b-badge variant="primary">
                              {{article.category.name}}
                            </b-badge>-->

            </b-td>

            <b-td>
              <b-badge variant="primary">
                <!--                {{article.user.first_name}} {{article.user.last_name}}-->
              </b-badge>

            </b-td>
            <b-td>
              <b-badge variant="success" v-if="article.status">
                منتشر شده
              </b-badge>
              <b-badge variant="danger" v-else>
                پیش نویس
              </b-badge>

            </b-td>
            <b-td>
              {{
                new Date(article.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>

            <b-td>
              <b-col class="d-flex align-items-center">
                <a
                    :href="`https://roomtoor.com/blog/${article.slug}`"
                    target="_blank"

                    class="font-weight-bolder"
                >
                  <feather-icon icon="EyeIcon" size="20" />
                </a>
                <b-button
                    @click="showConfirmModal(article)"
                    variant="flat-danger"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>
                <b-button
                    @click="showFormModal(article)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
          ref="residencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="90%"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش مقاله" : "ایجاد مقاله" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> عنوان : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.title" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="slug" class="text-capitalize"> اسلاگ | slug : </label>
          <b-form-input @input="removeErrors('slug')" id="slug" v-model="categoryInput.slug" type="text" />
          <ErrorMessage
              errorType="slug"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="parent_id" class="text-capitalize">انتخاب نویسنده :</label>
          <select
              id="parent_id"
              v-model="categoryInput.user_id"
              class="form-control"
          >
            <option value="" disabled>انتخاب کنید</option>
            <option v-for="user in users" :key="user.id" :value="user.id">
              {{ user.fullName }}
            </option>
          </select>
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="parent_id" class="text-capitalize">انتخاب دسته بندی مقاله :</label>
          <select
              id="parent_id"
              v-model="categoryInput.newscategory_id"
              class="form-control"
          >
            <option value="" disabled>انتخاب کنید</option>
            <option v-for="category in categories" :key="category.id" :value="category.id">
              {{ category.name }}
            </option>
          </select>
        </b-form-group>

        <b-form-group class="">
          <label for="imageIcon" class="text-capitalize">
            آپلود تصویر شاخص :
          </label>
          <FilePicker
              @inputFile="inputIconImageFile"
              :url="iconImageurl"
              ref="iconImageFilePicker"
              style="width: 400px"
          ></FilePicker>
          <ErrorMessage
              errorType="image"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> alt image   : </label>
          {{categoryInput.alt_image}}
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.alt_image" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>

        <b-col class="my-1 mb-6"      style="margin-bottom: 85px !important;">
          <b-form-group>
            <label for="description" class="text-capitalize"
            >توضیحات   :<span class="text-danger">*</span></label
            >
            <quill-editor
                ref="myQuillEditor"
                style=" direction: rtl !important;text-align: right !important;height: 600px;font-family: anjoman !important;"
                v-model="categoryInput.description"
                :options="editorOption"
                class="quill-editor-container"
            />
            <!--              <vue-editor
                            v-model="tourInput.description"
                            :editorToolbar="customToolbar"
                          ></vue-editor>-->
          </b-form-group>
        </b-col>

        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> مدت تایم خواندن مقاله (2 دقیقه)  : </label>
          <b-form-input @input="removeErrors('time_to_read')" id="time_to_read" v-model="categoryInput.time_to_read" type="text" />
          <ErrorMessage
              errorType="time_to_read"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> عنوان سئو (title)   : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.meta_title" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="slug" class="text-capitalize"> کلمات کلیدی keywords : </label>
          <b-form-input @input="removeErrors('slug')" id="slug" v-model="categoryInput.meta_keyword" type="text" />
          <ErrorMessage
              errorType="slug"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>


        <b-form-group class="mt-1">
          <label for="description" class="text-capitalize"> توضیحات سئو meta Description : </label>
          <b-form-textarea
              id="description"
              v-model="categoryInput.meta_description"
              type="text"
              @input="removeErrors('meta_description')"
          />
          <ErrorMessage
              errorType="description"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="parent_id" class="text-capitalize">وضعیت مقاله :</label>
          <select
              id="parent_id"
              v-model="categoryInput.status"
              class="form-control"
          >
            <option value="" disabled>انتخاب کنید</option>
            <option value="1">
              منتشر
            </option>
            <option value="0">
              پیش نویس
            </option>
          </select>
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="parent_id" class="text-capitalize">مقاله فوری  برای نمایش در صفحه اصلی :</label>
          <select
              id="parent_id"
              v-model="categoryInput.breaking_news"
              class="form-control"
          >
            <option value="" disabled>انتخاب کنید</option>
            <option value="1">
              فوری
            </option>
            <option value="0">
              معمولی
            </option>
          </select>
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd, BIconCalendar, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";
import QuillEditor from "vue-quill-editor/src/editor.vue";

export default {
  components: {
    BBadge,
    QuillEditor,
    BIconCalendar,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {
      searchId: '',
      searchSlug: '',
      searchTitle: '',

      editorOption: {
        placeholder: 'محتوای خود را وارد کنید...',
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{'header': [1, 2, 3, 4, 5, 6, false]}],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'script': 'sub'}, {'script': 'super'}],
              [{'indent': '-1'}, {'indent': '+1'}],
              [{'direction': 'rtl'}],
              [{'size': ['small', false, 'large', 'huge']}],
              [{'color': []}, {'background': []}],
              [{'font': []}],
              [{'align': []}],
              ['link', 'image', 'video'],
              ['clean']
            ],
            handlers: {
              image: function () {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');

                const altText = prompt('لطفاً متن جایگزین (alt) تصویر را وارد کنید:');

                input.click();

                input.onchange = () => {
                  const file = input.files[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                      const quill = this.quill;
                      const range = quill.getSelection(true);

                      quill.insertEmbed(range.index, 'image', e.target.result);

                      const image = quill.container.querySelector(`img[src="${e.target.result}"]`);
                      if (image) {
                        image.setAttribute('alt', altText || '');
                      }

                      quill.setSelection(range.index + 1);
                    };
                    reader.readAsDataURL(file);
                  }
                };
              }
            }
          }
        }
      },

      optionsShow:[
        { value: null, text: 'انتخاب نمایش در ص اصلی' },
        { value: '0', text: 'عدم نمایش در صفحه اصلی' },
        { value: '1', text: 'نمایش در صفحه اصلی' },
      ],

      iconImageurl:"",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      categories: [],
      news: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      users: [
        {
          id: 5790,
          fullName: "اشکان مولودی",
        },
        {
          id: 21,
          fullName: "محمد رضازاده",
        },
        {
          id: 1265,
          fullName: "صادق قنبرزاده",
        },
        {
          id: 865,
          fullName: "سعید جعفرزادگان",
        },
        {
          id: 685,
          fullName: "روم تور ",
        },
      ],


      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      categoryInput: {
        id: "",
        user_id: "",
        newscategory_id: "",
        slug:"",
        title:"",
        alt_image:"",
        image: "",
        description:"",
        status:"",
        breaking_news:"",
        time_to_read:"",
        meta_title: null,
        meta_keyword: null,
        meta_description: null,
      },
      editMode: false,
      formModal: false,
      submitLoading: false,


    };
  },
  mounted() {
    const editor = this.$refs.myQuillEditor.quill; // اطمینان حاصل کنید که ref="myQuillEditor" به کامپوننت quill-editor اضافه شده است

    editor.root.addEventListener('dblclick', (event) => {
      if (event.target && event.target.tagName === 'IMG') {
        const currentAlt = event.target.getAttribute('alt') || '';
        const newAlt = prompt('ویرایش متن جایگزین (alt) تصویر:', currentAlt);

        if (newAlt !== null) { // اگر کاربر Cancel را نزده باشد
          event.target.setAttribute('alt', newAlt);
        }
      }
    });
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getNews();
    this.getBuildings();
    this.getCategories();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getNews();
    },
    perPage(value) {
      this.page = 1;
      this.getNews();
    },
    searchId() {
      this.page = 1;
      this.getNews();
    },
    searchSlug() {
      this.page = 1;
      this.getNews();
    },
    searchTitle() {
      this.page = 1;
      this.getNews();
    },
    page() {
      this.getNews();
    }
  },
  methods: {
    inputIconImageFile(file) {
      this.removeErrors("image");
      if (file) {
        this.categoryInput.image = file;
      }
    },
    getCategories(search, loading) {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
      };

      const requestData = {
        method: "get",
        url: "/admin/newscategories",
        params: data,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.categories = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    removeErrors(data) {
      if (
          typeof this.errorMessage[data] !== "undefined" &&
          this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
            {},
            this.errorMessage,
            this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getNews();
    },

    getNews() {
      let params = {
        per_page: this.perPage,
        page: this.page
      };

      if (this.searchId) params.id = this.searchId;
      if (this.searchSlug) params.slug = this.searchSlug;
      if (this.searchTitle) params.title = this.searchTitle;

      this.$http.get('/admin/news', { params })
          .then((response) => {
            this.news = response.data.data;
            this.paginationData = response.data.meta;
          })
          .catch((error) => {
            console.log('خطا در دریافت اطلاعات:', error);
            this.news = [];
            this.$bvToast.toast('خطا در دریافت اطلاعات', {
              title: 'خطا',
              variant: 'danger',
              solid: true
            });
          });
    },
    showConfirmModal(category) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف مقاله مطمئن هستید ؟  : ${category.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.news = await this.news.filter(
                  (residenceItem, index) => {
                    if (residenceItem.id == category.id) {
                      residenceIndex = index;
                    }
                    return residenceItem.id !== category.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/news/${category.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `مقاله: ${category.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.news.splice(residenceIndex, 0, category);
                  });
            }
          });
    },
    showFormModal(category) {
      if (category) {
        this.categoryInput = {
          id: category.id,
          user_id: category.user_id,
          newscategory_id: category.newscategory_id,
          title: category.title,
          slug:category.slug,
          alt_image:category.alt_image,
          image: category.image,
          description: category.description,
          status: category.status,
          breaking_news: category.breaking_news,
          time_to_read: category.time_to_read,
          meta_title: category.meta_title,
          meta_keyword: category.meta_keyword,
          meta_description: category.meta_description,
        };
        //this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl = category.image
            ?  '/' + category.image
            : null;
        this.editMode = true;
      } else {
        this.categoryInput = {
          id: "",
          user_id: "",
          newscategory_id: "",
          slug:"",
          title:"",
          alt_image:"",
          image: "",
          description:"",
          status:"",
          breaking_news:"",
          time_to_read:"",
          meta_title: null,
          meta_keyword: null,
          meta_description: null,
        };
        // this.$refs.iconImageFilePicker.clearFileInput()
        // this.iconImageurl=""
        this.iconImageurl = null;
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!this.categoryInput.title) {
        this.errorMessage = { title: "لطفا عنوان مقاله را وارد کنید" };
      }
      if (!this.errorMessage && !this.categoryInput.slug) {
        this.errorMessage = { slug: "لطفا اسلاگ عنوان مقاله را وارد کنید" };
      }

      let formData = new FormData();

      formData.append("title", this.categoryInput.title);
      formData.append("slug", this.categoryInput.slug);

      if (this.categoryInput.newscategory_id) {
        formData.append("newscategory_id", this.categoryInput.newscategory_id);
      }
      if (this.categoryInput.user_id) {
        formData.append("user_id", this.categoryInput.user_id);
      }
      if (this.categoryInput.image && this.categoryInput.image instanceof File) {
        formData.append("image", this.categoryInput.image);
      }
      if (this.categoryInput.description) {
        formData.append("description", this.categoryInput.description);
      }
      if (this.categoryInput.meta_title) {
        formData.append("meta_title", this.categoryInput.meta_title);
      }
      if (this.categoryInput.alt_image) {
        formData.append("alt_image", this.categoryInput.alt_image);
      }
      if (this.categoryInput.meta_keyword) {
        formData.append("meta_keyword", this.categoryInput.meta_keyword);
      }
      if (this.categoryInput.meta_description) {
        formData.append("meta_description", this.categoryInput.meta_description);
      }
      if (this.categoryInput.status) {
        formData.append("status", this.categoryInput.status);
      }
      if (this.categoryInput.breaking_news) {
        formData.append("breaking_news", this.categoryInput.breaking_news);
      }
      if (this.categoryInput.time_to_read) {
        formData.append("time_to_read", this.categoryInput.time_to_read);
      }
      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
            ? `/admin/news/update/${this.categoryInput.id}`
            : `/admin/news`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      this.$http(requestData)
          .then((response) => {
            let message = "مقاله با موفقیت اضافه شد";
            if (this.editMode) message = "مقاله با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.buildings && this.buildings.length > 0) {
              this.$refs.residencesPaginationComponent.clear();
              // this.$refs.residencesSearchComponent.clear();
              this.$refs.residencesTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getNews();
            location.reload();
            return;
          })
          .catch((err) => {
            let message = "خطا در ایجاد مقاله";
            if (this.editMode) message = "خطا در ویرایش مقاله";
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.message
            )
              message = err.response.data.response.message;
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.meta &&
                err.response.data.response.meta.errors
            )
              this.errorMessage = err.response.data.response.meta.errors;
            console.log("this.errorMessage", this.errorMessage);

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data.data;
            this.buildings = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.ql-container .ql-editor{
  font-family: anjoman !important;
}

</style>
